import React, { useState, Fragment } from "react";
import Icofont from 'react-icofont';
import NumericInput from 'react-numeric-input';
import { STRIPE_ID } from '../../constants/Payment';

const STRIPE_ONCE = "sku_GL8X2mnXwS5mJx";

const Once = props => {

    const [quantity, setQuantity] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const stripeOnClick = (planId) => {
        if (quantity < 10) {
            setErrorMsg("輸入金額至少為10元。");
            return;
        }

        setErrorMsg("");
        let stripe = window.Stripe(STRIPE_ID);       //pk_live_PsMmbdMS6qsptv9VeTHO083h00IZdYdFgr
        stripe.redirectToCheckout({
            items: [{ sku: planId, quantity: quantity }],

            // Do not rely on the redirect to the successUrl for fulfilling
            // purchases, customers may not always reach the success_url after
            // a successful payment.
            // Instead use one of the strategies described in
            // https://stripe.com/docs/payments/checkout/fulfillment
            successUrl: 'https://news.hkgolden.com/success',
            cancelUrl: 'https://news.hkgolden.com/canceled',
            locale: 'en'
        })
            .then(function (result) {
                if (result.error) {
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer.
                    var displayError = document.getElementById('error-message');
                    displayError.textContent = result.error.message;
                }
            });
    }

    const paypalOnClick = () => {
        if (quantity < 10) {
            setErrorMsg("輸入金額至少為10元。");
            return;
        }

        setErrorMsg("");
        
        window.open(`https://www.paypal.me/hkgolden/${quantity}?country.x=HK`, '_blank')
    }

    const renderStripeOnceBtn = () => {
        return (
            <button className="button payment-button" onClick={() => stripeOnClick(STRIPE_ONCE, quantity)}>
                <Icofont className="payment-icon" icon="icofont-stripe" />
                <div className="mask" />
            </button>
        )
    }

    const quantityOnChange = (value) => {
        setQuantity(value);
    }

    const renderPaypalOnceBtn = () => {
        return (
            <button onClick={paypalOnClick} className="button payment-button">
                <Icofont className="payment-icon" icon="icofont-paypal" />
                <div className="mask" />
            </button>
        );
    }

    return (
        <Fragment>
            <h3>單次贊助我們可選擇以下付款方式：</h3>
            <div className="payment-method">
                <h3>一、網上付款</h3>
                <div className="instruction-container">
                    <div className="payment-instruction">
                        <ol>
                            <li>請先輸入欲贊助之金額再選擇付款方式</li>
                            <li>按 Stripe / PayPal 網頁指示輸入個人資料，並完成付款程序</li>
                            <li>我們將透過電郵確認你的付款支持</li>
                        </ol>
                    </div>
                </div>
                <div><p>金額：$ <NumericInput strict onChange={quantityOnChange} value={quantity} min={10} max={100000000} /> HKD</p></div>
                <div className="payment">
                    {renderStripeOnceBtn()}
                    {renderPaypalOnceBtn()}
                </div>
                <p className="error-msg">{errorMsg || ""}</p>
            </div>
            <div className="payment-method">
                <h3>二、轉數快 FPS</h3>
                <div className="instruction-container">
                    <div className="payment-instruction">
                        <ol>
                            <li>先登入閣下的網上銀行戶口</li>
                            <li>在FPS選擇電郵地址「1201714」及填妥金額</li>
                            <li>完成後請將截圖以附件形式電郵至<b><a rel="noopener noreferrer" target="_blank" href="mailto:marketing@alivemedia.com.hk">marketing@alivemedia.com.hk</a></b></li>
                            <li>電郵主旨​請註明「高登新聞台月費計劃」</li>
                            <li>我們將透過電郵確認你的付款支持</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className="payment-method">
                <h3>三、Payme</h3>
                <div className="instruction-container">
                    <div className="payment-instruction">
                        <ol>
                            <li>使用Payme QR code掃瞄器讀取連結</li>
                            <li>完成後請將截圖以附件形式電郵至<b><a rel="noopener noreferrer" target="_blank" href="mailto:marketing@alivemedia.com.hk">marketing@alivemedia.com.hk</a></b></li>
                            <li>電郵主旨​請註明「高登新聞台月費計劃」</li>
                            <li>我們將透過電郵確認你的付款支持</li>
                        </ol>
                    </div>
                </div>
                <div><img className="qr" src={require("../../assets/img/Payme.jpeg")} alt="payme" /></div>
            </div>
            <div className="payment-method">
                <h3>四、銀行轉帳</h3>
                <div className="instruction-container">
                    <div className="payment-instruction">
                        <ol>
                            <li>請將贊助金額轉賬到<br/>
                                <b>活現媒體註冊公司 Alive! Media & Communications Limited</b><br/>
                                <b>恆生銀行戶口：295-571848-883</b><br/>
                            </li>
                            <li>來郵封面或電郵主旨​請註明「高登新聞台月費計劃」</li>
                            <li>我們將透過電郵確認你的付款支持</li>
                        </ol>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
export default Once;